
import { defineComponent, ref } from 'vue';
import { useField } from 'vee-validate';
import { string } from 'yup';

import useCompany from '@/stores/company';
import MoCaptcha from '@mo/captcha';

import { DOCUMENT_TYPE } from '@/models/legalDocument';

const ROUTE_BY_NAME: {
  [x: string]: string;
} = {
  'c-cart': '/c/user/orders/cart',
};

export default defineComponent({
  name: 'PhoneForm',

  props: {
    errorMessage: {
      type: String,
      default: '',
    },
    redirectRoute: {
      type: String,
      default: '',
    },
    captchaError: {
      type: String,
      default: '',
    },
    isVisibleCaptcha: {
      type: Boolean,
      default: false,
    },
    currentPhone: {
      type: String,
      default: '',
    },
  },

  emits: ['send', 'clearError'],

  setup() {
    const {
      validate,
      value: phone,
      meta,
    } = useField<string>(
      'phone',
      string()
        .required()
        .matches(/\+\d{11}/, 'Номер телефона должен содержать 11 цифр.')
    );

    return {
      validate,
      phone,
      meta,
      mask: '+7 (###) ###-##-##',
      companyStore: useCompany(),
      DOCUMENT_TYPE,
    };
  },

  data(): {
    isConfirmed: false;
    captcha: string | null;
    currPhone: string;
    moCaptcha: MoCaptcha | null,
    } {
    return {
      isConfirmed: false,
      captcha: null,
      currPhone: this.currentPhone,
      moCaptcha: null as MoCaptcha | null,
    };
  },

  computed: {
    moAuthUrl(): string {
      const backlink = this.redirectRoute
        ? `${window.location.origin}${ROUTE_BY_NAME[this.redirectRoute]}`
        : window.location.href;

      return (
        `${window.location.origin}` +
        `/api/auth/${this.companyStore.activeCompany?.login}/oauth2/sign-in` +
        `?back_url=${backlink}`
      );
    },

    isSendCodeAllowed(): boolean {
      return this.meta.valid && this.isConfirmed && !(this.isVisibleCaptcha && !this.captcha);
    },
  },

  methods: {
    send() {
      if (!this.isSendCodeAllowed) {
        return;
      }
      this.$emit('send', this.phone, this.captcha);
    },

    initMoCaptcha() {
      this.moCaptcha = new MoCaptcha('captcha-container', {
        titleText: 'Вы не робот?',
        manualText: 'Проведите вправо',
        onSuccess: this.onCaptchaSuccess,
        onFail: () => {},
      });
    },

    onCaptchaSuccess(token: string) {
      this.captcha = token;
    },

  },

  mounted() {
    if (this.isVisibleCaptcha) {
      this.initMoCaptcha();
    }
  },

  watch: {
    isVisibleCaptcha(newVal: boolean) {
      if (newVal) {
        this.$nextTick(() => {
          this.initMoCaptcha();
        });
      }
    },

    captchaError(newVal: string) {
      if (newVal && this.moCaptcha) {
        this.moCaptcha!.reset();
      }
    },
  },
});
